import SectionTitle from "./SectionTitle";

const About = () => {
  return (
    <section id="about" className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_top,_rgba(107,15,15,0.4),_transparent_55%),_radial-gradient(circle_at_bottom,_rgba(212,166,74,0.25),_transparent_60%)]" />
      <div className="container relative">
        <div className="glass-panel rounded-[32px] border border-white/10 p-10 md:p-16 backdrop-blur-2xl">
          <SectionTitle
            eyebrow="Our Story"
            title="Panu Pannai Veetu Biryani"
            description="Rooted in the heart of Tamil Nadu, Panu Pannai Veetu Biryani brings traditional home-style biryani to modern dining. Every pot carries the aroma of firewood, seeraga samba rice, and generations of family recipes crafted with love."
          />
          <div className="grid gap-10 md:grid-cols-3">
            {[
              "Firewood Dum Cooking",
              "Ancestral Masala Craft",
              "Authentic Village Experience",
            ].map((item) => (
              <div
                key={item}
                className="p-6 rounded-2xl border border-white/10 bg-white/5 text-brand-cream"
              >
                <h3 className="text-xl font-display mb-3">{item}</h3>
                <p className="text-brand-cream/70 text-sm">
                  {item === "Firewood Dum Cooking" &&
                    "Every biryani is slow-cooked in traditional firewood stoves, locking deep flavours into each grain."}
                  {item === "Ancestral Masala Craft" &&
                    "Our masalas are stone-ground daily using family recipes passed down through generations."}
                  {item === "Authentic Village Experience" &&
                    "From banana-leaf plating to clay-pot servings, we recreate the warmth of a true Tamil household feast."}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
